import { render } from "./СookiesPopup.vue?vue&type=template&id=32cca3fe&scoped=true"
import script from "./СookiesPopup.vue?vue&type=script&lang=js"
export * from "./СookiesPopup.vue?vue&type=script&lang=js"

import "./СookiesPopup.vue?vue&type=style&index=0&id=32cca3fe&scoped=true&lang=css"

import exportComponent from "/Users/kudamoi/projects/freedom/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cca3fe"]])

export default __exports__